const u = navigator.userAgent
export const device = (() => {
  const result = /AppleWebKit|Trident|Presto|Gecko/.exec(u)
  const kernel = result ? result[0] : ''
  // ios终端
  let platform = 'web'
  if (/\(i[^;]+;( U;)? CPU.+Mac OS X/.test(u)) {
    platform = 'ios'
  } else if (/Android|Linux/.test(u)) {
    platform = 'android'
  }
  return {
    kernel,
    platform,
    // 是否为iPhone或者QQHD浏览器
    isiPhone: u.includes('iPhone'),
    // 是否iPad
    isiPad: u.includes('iPad'),
    // 是否web应该程序，没有头部与底部
    isWebApp: u.includes('Safari'),
    // 是否为移动终端
    isMobile: /AppleWebKit.*Mobile.*/.test(u),
    standalone: u.toLowerCase().indexOf('umoocapp') > -1
  }
})()
